import { useEffect, useState } from 'react'

import { reportsTimeApi } from '@/api/reportsTime.api'

import { useDebounce } from './useDebounce'

export const useTimesheetActivities = (search: string, enabled = true) => {
  const [data, setData] = useState<string[]>([])
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<any>(null)

  const debouncedSearch = useDebounce(search, 300)

  useEffect(() => {
    if (!enabled) return

    const fetchActivities = async () => {
      setIsLoading(true)
      try {
        const response = await reportsTimeApi.getTimeActivities({
          name: debouncedSearch,
          limit: 100
        })
        setData(response.Activities ?? [])
        setError(null)
      } catch (err) {
        setError(err)
      } finally {
        setIsLoading(false)
      }
    }

    fetchActivities()
  }, [debouncedSearch, enabled])

  return { data, isLoading, error }
}
